import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faMobileAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";




class InvoiceScanView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.uuid = this.app.guid();

		this.order = this.props.order;
		
		this.closing = false;

		this.state = {
			message_text: 'scanning...',
			invoices: []
		};
	}

	_setState(state) {
		if (this.closing !== true)
		this.setState(state);
	}

	
	// post render commit phase
	componentDidMount() {
		console.log('InvoiceScanView.componentDidMount called');

		let mvcmodule = this.getMvcModuleObject();
		
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));

		this._scan();
	}

	async _scan() {
		if (this.order) {
			let mvcmodule = this.getMvcModuleObject();
			let mvcmyquote = this.getMvcMyQuoteObject();
	
			let rootsessionuuid = this.props.rootsessionuuid;
			let walletuuid = this.props.currentwalletuuid;

			let currencyuuid = this.order.currencyuuid;
			let orderhash = this.order.txhash;

			let invoices = [];
			let message_text = '';

			let canfetch = await mvcmyquote.canFetchTransactions(rootsessionuuid, walletuuid, currencyuuid);

			if (canfetch) {
				invoices = await mvcmyquote.fetchInvoices(rootsessionuuid, walletuuid, currencyuuid, orderhash)
				.catch(err => {
					console.log('error in InvoiceScanView._scan: ' + err);
				});
	
				message_text = 'found ' + (invoices ? invoices.length : 0) + ' invoices';

				for (var i = 0; i < (invoices ? invoices.length : 0); i++) {
					invoices[i].uuid = invoices[i].txhash;

					invoices[i].time = (invoices[i].savetime ? invoices[i].savetime/1000 : invoices[i].blocktime);
					invoices[i].formattedtime = mvcmodule.formatDate(invoices[i].time, 'YYYY-mm-dd HH:MM:SS');

					let tokenamount = await mvcmyquote.getCurrencyAmount(rootsessionuuid, currencyuuid, invoices[i].amount);
					let amountstring = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, tokenamount);
					invoices[i].amountstring = amountstring;
		
				}
	
				// sort descending invoices
				if (invoices)
				invoices.sort(function(a,b) {return ((b.time !== undefined ? b.time : 0) - (a.time !== undefined ? a.time : 0));});
	
			}
			else {
				/*let blockshift = 1000;
			
 				let new_invoices = await mvcmyquote.scanNextBlockForInvoices(rootsessionuuid, currencyuuid, orderhash, blockshift)
				.catch(err => {
					console.log('error in InvoiceScanView._scan: ' + err);
				}); */				
			}
			

			this._setState({message_text, invoices})
		}	
	}
	
	async onRefreshPage() {
		console.log('InvoiceScanView.onRefreshPage called');
		//this._scan();
	}
	
	// end of life
	componentWillUnmount() {
		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		this.closing = true;

		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
	}

	
	// user actions
	async onClickItem(item) {
		let txhash = item.txhash;
		let currencyuuid = item.currencyuuid;

		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let invoice = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, txhash)
		.catch(err => {
			console.log('error in InvoiceListView.onClickItem ' + err);
		});

		if (!invoice) {
			this.app.alert('Could not find invoice. Invoices may take a few seconds before being fully registered.')
			return;
		}

		let params = {action: 'view', txhash, currencyuuid, dataobject: invoice};

		this.app.gotoRoute('invoice', params);
	}

	renderItem(item){
		let formattedtime = item.formattedtime;
		let amountstring = item.amountstring;
		let uuid= item.txhash;

		return (
			<tr key={uuid} onClick={() => this.onClickItem(item)}>
				<th>{formattedtime}</th>
				<th>{amountstring}</th>
			</tr>
		);

	}

	renderList() {
		let items = this.state.invoices;

		return (
			<Table responsive>
				<thead className="ListHeader">
					<tr>
					<th>Time</th>
					<th>Amount</th>
					</tr>
				</thead>
				<tbody className="ListItem" >
				{items.map((item, index) => {
					return (this.renderItem(item));
				})}
				</tbody>
			</Table>
		);

	}
	
	// rendering
	render() {
		let { message_text, invoices } = this.state;
		
		return (
			<div className="Container">
				{(invoices && invoices.length ? 
				<div>
					<div className="Title">List of Invoices</div>
					<div className="TextBox">
					{message_text}
					{this.renderList()}
					</div>
				</div> :
				<></>)}
			</div>
		  );
	}
	
}


// propTypes validation
InvoiceScanView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {InvoiceScanView};
export default connect(mapStateToProps, mapDispatchToProps)(InvoiceScanView);

